export const VENDOR_PRODUCT_OPTIONS = [
  { slug: "cement", label: "Cement", routeSlug: "cement" },
  { slug: "steel-tmt", label: "Steel TMT Bars", routeSlug: "steel-tmt" },
  { slug: "structural-steel", label: "Structural Steel", routeSlug: "structural-steel" },
  { slug: "pvc-pipes", label: "DI Pipes", routeSlug: "di-pipes" },
  { slug: "Acc-block", label: "ACC Blocks", routeSlug: "Acc-block" },
];

export const BRANDS_BY_PRODUCT = {
  cement: [
    "JSW",
    "Zuari",
    "Sagar",
    "Ramco",
    "Ultratech",
    "Ambuja",
    "ACC",
    "Shree Cement",
    "Dalmia",
    "Bharathi Cement",
    "KCP Cement",
    "Priya",
  ],
  "steel-tmt": [
    "JSW",
    "Tata",
    "Vizag",
    "Simhadri",
    "Rada TMT",
    "Jairaj",
    "Kamachi",
  ],
  "structural-steel": [
    "JSW",
    "Tata",
    "Vizag",
    "Simhadri",
    "Rada TMT",
    "Jairaj",
    "Kamachi",
  ],
  "pvc-pipes": [
    "JSW",
    "Tata",
    "Electro Steel Casting Ltd.",
    "Rashmi Metaliks Ltd.",
    "Sri Kalahasthi",
    "Electro Therm Ltd.",
  ],
  "Acc-block": ["Ultra Tech", "Infra Market"],
};

export function getBrandsForProduct(slug) {
  return BRANDS_BY_PRODUCT[slug] || [];
}
